import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '3rem auto',
    textAlign: 'start',
  },
  linkNameInput: {
    width: '50%',
    margin: '0 auto',
  },
  fileUpload: {
    marginBottom: '8rem',
    textAlign: 'left',
    borderTop: `0.1rem solid ${colors.neutral[300]}`,
    marginTop: '4rem',
    paddingTop: '4rem',
  },
  currentPortfolioName: {
    margin: '0 0.5rem',
    color: colors.neutral[900],
  },
  uploadModal: {
    '& [class^="modalTitle"]': {
      marginBottom: '1rem',
    },
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
